import { GoodgameSignal } from "./GoodgameSignal";

/**
 *    ObjectSignal
 *
 *     @author Alexander
 */

export class ObjectSignal extends GoodgameSignal {
    constructor() {
        super();
    }

    public signal(params: Object): void {
        super.dispatch(params);
    }
}
